module.exports = __webpack_public_path__ + "img/6554693.1b1bf7ef.png";